<script setup lang="ts">
import MoneyAmount from '@/app/components/MoneyAmount.vue'
import { signTone } from '@/app/accounting-view'
import { negateMoney } from '@taler/domain'
import { computed } from 'vue'
import type { CarEvent } from '../internal/types.ts'

const props = defineProps<{ event: CarEvent }>()

// The event's amount is the journal entry's own total (debit-positive), so the money's direction is its
// negation: a cost reads minus, a sale or a refund reads plus, whatever the event type.
const value = computed(() => {
  const amount = props.event.amount
  return amount === undefined ? undefined : negateMoney(amount)
})
</script>

<template>
  <span v-if="value === undefined">—</span>
  <MoneyAmount v-else :value="value" sign :tone="signTone(value)" />
</template>
